import { VNominationDocumentTypes, type VNominationDocumentType } from "@constants/certificates";

export const NOMINATION_DOCUMENTS_FIELD = "documents";

export const NominationDocumentFields = Object.freeze({
  URL: "url",
  DOCUMENT_NAME: "documentName",
  TYPE: "type",
  OTHER_SPECIFY: "otherSpecify",
  ISSUE_DATE: "issueDate",
  EXPIRY_DATE: "expiryDate",
  NOR_TIME: "norTime",
});

const nominationDocumentTypes = Object.values(
  VNominationDocumentTypes,
) as VNominationDocumentType[];

export const VESSEL_NOMINATION_COLUMNS = Object.freeze({
  NOMINATION_ID: "nominationId",
  NOMINATION_TYPE: "nominationType",
  IMO_NUMBER: "imoNumber",
  VESSEL_NAME: "vesselName",
  PORT: "port",
  ETA: "eta",
  AGENCY_NAME: "agencyName",
  NOMINATION_DATE_TIME: "nominationDateTime",
  STATUS: "status",
});
// need to align the names with the BE
export const generateCertificateField = {
  fileUrl: (docType: VNominationDocumentType) =>
    `${NOMINATION_DOCUMENTS_FIELD}.${docType}.${NominationDocumentFields.URL}` as const,
  documentName: (docType: VNominationDocumentType) =>
    `${NOMINATION_DOCUMENTS_FIELD}.${docType}.${NominationDocumentFields.DOCUMENT_NAME}` as const,
  documentType: (docType: VNominationDocumentType) =>
    `${NOMINATION_DOCUMENTS_FIELD}.${docType}.${NominationDocumentFields.TYPE}` as const,
  otherSpecify: (docType: VNominationDocumentType) =>
    `${NOMINATION_DOCUMENTS_FIELD}.${docType}.${NominationDocumentFields.OTHER_SPECIFY}` as const,
  issueDate: (docType: VNominationDocumentType) =>
    `${NOMINATION_DOCUMENTS_FIELD}.${docType}.${NominationDocumentFields.ISSUE_DATE}` as const,
  expiryDate: (docType: VNominationDocumentType) =>
    `${NOMINATION_DOCUMENTS_FIELD}.${docType}.${NominationDocumentFields.EXPIRY_DATE}` as const,
  norTime: (docType: VNominationDocumentType) =>
    `${NOMINATION_DOCUMENTS_FIELD}.${docType}.${NominationDocumentFields.NOR_TIME}` as const,
};
export const nominationDocumentDateKeys = nominationDocumentTypes.flatMap((type) => [
  generateCertificateField.issueDate(type),
  generateCertificateField.expiryDate(type),
]);
// need to align the names with the BE
export const generateAdditionalDocumentField = {
  fileUrl: (index: number) => `additionalNominationDocuments.${index}.documentUrl`,
  documentType: (index: number) => `additionalNominationDocuments.${index}.documentType`,
  otherSpecify: (index: number) => `additionalNominationDocuments.${index}.otherSpecify`,
  issueDate: (index: number) => `additionalNominationDocuments.${index}.issueDate`,
  expiryDate: (index: number) => `additionalNominationDocuments.${index}.expiryDate`,
} as const;
